const STORAGE_KEY = 'simsrandom.excludedPacks'

class Filter {

  constructor() {
    this.button = document.querySelector('#filterBtn')
    this.packs = []
    this.filterContainer = document.querySelector('.filter')
    this.restore()
    this.filterButtonListener()
    this.filterListener()
  }

  filterButtonListener() {
    this.button.addEventListener('click', () => {
      if (this.button.classList.contains('open')) {
        this.close()
      } else {
        this.open()
      }
    })
  }

  open() {
    this.filterContainer.inert = false
    this.filterContainer.style.maxHeight = this.filterContainer.scrollHeight + "px"
    this.button.classList.add('open')
    this.button.setAttribute('aria-expanded', 'true')
  }

  // Close the filter panel. Resolves when the closing transition is done
  close() {
    return new Promise(resolve => {
      if (!this.button.classList.contains('open')) return resolve()
      this.button.classList.remove('open')
      this.button.setAttribute('aria-expanded', 'false')
      this.filterContainer.inert = true
      const done = () => {
        clearTimeout(fallback)
        this.filterContainer.removeEventListener('transitionend', onEnd)
        resolve()
      }
      const onEnd = ev => { if (ev.target === this.filterContainer && ev.propertyName === 'max-height') done() }
      const fallback = setTimeout(done, 400)
      this.filterContainer.addEventListener('transitionend', onEnd)
      this.filterContainer.style.maxHeight = "0px"
    })
  }

  filterListener() {
    this.filterContainer.addEventListener('click', ev => {
      if (ev.target.classList.contains('filterItem')) {
        this.setExcluded(ev.target, !this.packs.includes(ev.target.dataset.pack))
      }
      // "Disable all"/"Enable all"-buttons
      if (ev.target.classList.contains('disable-all') || ev.target.classList.contains('enable-all')) {
        let exclude = ev.target.classList.contains('disable-all')
        let type = ev.target.getAttribute('data-type')
        let parent = document.querySelector(`.filterGroup__grid[data-type=${type}]`)
        parent.querySelectorAll('.filterItem').forEach(item => this.setExcluded(item, exclude))
      }
      this.save()
    })
  }

  setExcluded(item, exclude) {
    let pack = item.dataset.pack
    item.classList.toggle('filterItem--disabled', exclude)
    item.setAttribute('aria-pressed', exclude ? 'false' : 'true')
    if (exclude && !this.packs.includes(pack)) this.packs.push(pack)
    if (!exclude && this.packs.includes(pack)) this.packs.splice(this.packs.indexOf(pack), 1)
  }

  // Remember excluded packs between visits
  save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.packs))
    } catch (e) {}
  }

  restore() {
    let saved = []
    try {
      saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []
    } catch (e) {}
    if (!Array.isArray(saved)) return
    this.filterContainer.querySelectorAll('.filterItem').forEach(item => {
      if (saved.includes(item.dataset.pack)) this.setExcluded(item, true)
    })
  }

}

export default Filter
